<template>
  <div class="chooseNearest">
    <span v-if="!$attrs['hide-text']" class="textBtn font-size-12" @click="handleShowNearest">
      {{ $t('home.nearest.title') }}
    </span>
    <q-dialog v-model="block" content-class="nearestInputDialog">
      <q-card class="no-border-radius dialogContent">
        <q-card-section class="q-py-none">
          <q-banner dense inline-actions class="q-px-none q-py-sm q-my-xs">
            <span class="font-size-14 text-weight-bolder">
              {{ $t('home.nearest.location') }}
            </span>
            <template #action>
              <q-btn v-close-popup size="xs" unelevated round flat>
                <q-icon size="16px" name="font:dm-close" />
              </q-btn>
            </template>
          </q-banner>
        </q-card-section>
        <q-card-section class="q-pb-md">
          <ChangePosition :adderss="place.address" @showMap="handleShowMap" />
        </q-card-section>
      </q-card>
    </q-dialog>

    <Store
      :show.sync="allow"
      :place="place"
      :delivery="delivery"
      @showMap="showMap = true"
    />

    <Place
      v-model="showMap"
      :point="place.position"
      @setPlace="handleSetPlace"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { loadGoogleMap } from 'components/utils';
import ChangePosition from './ChangePosition.vue';
import Store from './Store.vue';
import Place from './Place.vue';

export default {
  components: {
    ChangePosition,
    Store,
    Place,
  },
  props: {
    position: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      allow: false,
      block: false,
      showMap: false,
      place: {
        address: '',
        position: {
          lng: '',
          lat: '',
        },
      },
      delivery: false,
    };
  },
  computed: {
    ...mapState({
      localAddress: state => state.Menu.addressInfo ?? {},
    }),
  },
  methods: {
    handleShowNearest(type) {
      this.delivery = type === 'DELIVERY';
      const place = this.$q.localStorage.getItem('place');
      navigator.geolocation.getCurrentPosition(
        async pos => {
          this.allow = true;
          if (place) {
            this.place = place;
          } else {
            const position = {
              lng: pos.coords.longitude,
              lat: pos.coords.latitude,
            };
            this.place.position = position;
            await loadGoogleMap();
            const maps = window.google?.maps;
            if (!maps) return;
            const geocoder = new maps.Geocoder();
            geocoder.geocode({ location: position }, (results, status) => {
              if (results.length > 0) {
                const addressArr = results[0].address_components.map(
                  item => item.short_name,
                );
                this.place.address = addressArr.join(' ');
              }
            });
          }
        },
        err => {
          this.block = true;
          if (place) {
            this.place = place;
          }
        },
      );
    },
    handleShowMap() {
      const place = this.$q.localStorage.getItem('place');
      navigator.geolocation.getCurrentPosition(
        pos => {
          const position = {
            lng: pos.coords.longitude,
            lat: pos.coords.latitude,
          };
          this.place.position = position;
          this.showMap = true;
        },
        err => {
          if (place) {
            this.place = place;
          } else {
            this.place.position = this.position;
          }
          this.showMap = true;
        },
      );
      // this.showMap = true;
    },
    handleSetPlace(val) {
      this.place = val;
      this.block = false;
      this.allow = true;
    },
  },
};
</script>

<style lang="scss">
.chooseNearest {
  display: inline;
  border-radius: 8px;
  .textBtn {
    margin-left: 6px;
    color: $primary;
  }
}
.nearestInputDialog {
  .q-dialog__inner {
    padding: 0;
  }
  .dialogContent {
    width: 92%;
    border-radius: 8px !important;
    .changePosition {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f3f4f6;
      border-radius: 10px;
      padding: 8px;
      .left {
        display: flex;
        align-items: self-end;
        span {
          color: #8a8a8d;
        }
      }
      .q-btn {
        font-weight: 800;
        font-size: 12px;
        line-height: 1px;
        color: $primary;
        .q-btn__wrapper {
          padding: 0;
        }
      }
    }
  }
}
</style>
